var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.16 21.9999C13.0044 21.9998 12.8512 21.9586 12.7144 21.8799L0.49353 14.8799L1.38471 13.1199L13.16 19.8639L24.9352 13.1199L25.8264 14.8799L13.6056 21.8799C13.4687 21.9586 13.3156 21.9998 13.16 21.9999Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.16 27.9999C13.0044 27.9998 12.8513 27.9586 12.7144 27.8799L0.493559 20.8799L1.38474 19.1199L13.16 25.8639L24.9353 19.1199L25.8264 20.8799L13.6056 27.8799C13.4687 27.9586 13.3156 27.9998 13.16 27.9999ZM13.16 15.9999C13.0044 15.9998 12.8513 15.9586 12.7144 15.8799L0.493559 8.87987C0.344322 8.79418 0.219655 8.66715 0.132765 8.51223C0.0458752 8.35731 0 8.18027 0 7.99987C0 7.81947 0.0458752 7.64243 0.132765 7.48751C0.219655 7.33259 0.344322 7.20555 0.493559 7.11987L12.7144 0.119869C12.8513 0.0412724 13.0044 0.00012207 13.16 0.00012207C13.3156 0.00012207 13.4687 0.0412724 13.6056 0.119869L25.8264 7.11987C25.9757 7.20555 26.1003 7.33259 26.1872 7.48751C26.2741 7.64243 26.32 7.81947 26.32 7.99987C26.32 8.18027 26.2741 8.35731 26.1872 8.51223C26.1003 8.66715 25.9757 8.79418 25.8264 8.87987L13.6056 15.8799C13.4687 15.9586 13.3156 15.9998 13.16 15.9999ZM2.92269 7.99987L13.16 13.8639L23.3973 7.99987L13.16 2.13587L2.92269 7.99987Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/productIcon.d8c9a805612b52372d184a8833ee549e.svg";
export { ForwardRef as ReactComponent };